/**
 * 平台功能点/增购项
 */
export enum PlatformVipAddOnKey {
    /** 成员自动同步 */
    user_sync = 'user_sync',
    /** 单点登录 */
    sso = 'sso',
    /** 自定义登录页 */
    custom_login = 'custom_login',
    /** 连接企业数 */
    corp_coop = 'corp_coop',
    /** 对接人数 */
    corp_coop_docker = 'corp_coop_docker',
    /** 企业高管（提醒屏蔽） */
    corp_executive = 'corp_executive',
    /** 授权管理（成员启/停用) */
    member_freeze = 'member_freeze',
    /** 平台API */
    data_api = 'data_api',
    /** 开放平台 */
    open = 'open',
    /** 开放平台自建插件 */
    open_private_plugin = 'open_private_plugin',
    /** 系统管理员数 */
    sys_admin = 'sys_admin',
    watermark = 'watermark',
    corp_theme = 'corp_theme',
    /** AI实验室 */
    ai_lab = 'ai_lab',
    /** 集成应用 */
    open_application = 'open_application',
    /** 成员api */
    member_api = 'member_api',
    /** 日志api */
    log_api = 'log_api'
}

/**
 * 平台版本
 */
export enum PlatformVipLevel {
    free = 'free', // 免费版
    trial = 'trial', // 试用版
    advanced = 'advanced' // 高级版
}

export interface PlatformVip {
    pack: Record<PlatformVipAddOnKey, number>;
    /** 可增购的功能项 */
    upgradable_addons: PlatformVipAddOnKey[];
    plan: PlatformVipLevel;
}

export interface SuiteVip {
    pack: { level: string };
}
